import { render, staticRenderFns } from "./WfDevPermissionListModal.vue?vue&type=template&id=67427fc1&scoped=true&"
import script from "./WfDevPermissionListModal.vue?vue&type=script&lang=js&"
export * from "./WfDevPermissionListModal.vue?vue&type=script&lang=js&"
import style0 from "./WfDevPermissionListModal.vue?vue&type=style&index=0&id=67427fc1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67427fc1",
  null
  
)

export default component.exports